import { createFileRoute } from "@tanstack/react-router";
import Integritetspolicy from "@/pages/Integritetspolicy";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/integritetspolicy")({
  head: () =>
    buildSeoHead(publicPageSeo.integritetspolicy, [
      buildPageSchema(publicPageSeo.integritetspolicy, "WebPage"),
      buildBreadcrumbSchema(getBreadcrumbTrail("/integritetspolicy") ?? []),
    ]),
  component: Integritetspolicy,
});
